import React from 'react'

import EnterpriseProfile from '../components/enterprise/profile'

const EnterpriseProfilePage = ({ match }) => {
    
    return(
        <EnterpriseProfile
            pageKey={match.params.pageKey}
            enterpriseId ={ match.params.enterpriseId}
        />
    )

}

export default EnterpriseProfilePage;


// WEBPACK FOOTER //
// ./src/containers/enterprise-profile-page.js